import { Controller } from "stimulus"

export default class extends Controller {
  static values = { orderItemIds: Array, orderIds: Array, view: String, manageQueryParamsKey: String, subscriptionIds: Array}

  connect() {
    console.log("LazyLoader connected 🚀")
    const manageQueryParamsQuery = this.manageQueryParamsKeyValue ? `manage_query_params_key=${this.manageQueryParamsKeyValue}` : ""
    this.orderIdsValue.forEach(id => {
      fetch(`/subscriptions/manage/order_payment/${id}?view=${this.viewValue}&mobilitybox_subscription_ids=${this.subscriptionIdsValue}&${manageQueryParamsQuery}`)
        .then(response => response.text())
        .then(html => {
          const el = document.querySelector(`#payment_order_${id}`)
          if (el) {
            el.outerHTML = html
          }
        })
    })
    this.orderItemIdsValue.forEach(id => {
      fetch(`/subscriptions/manage/${id}?view=${this.viewValue}&mobilitybox_subscription_ids=${this.subscriptionIdsValue}&${manageQueryParamsQuery}`)
        .then(response => response.text())
        .then(html => {
          const el = document.querySelector(`#mobilitybox_order_item_${id}`)
          if (el) {
            el.outerHTML = html
            loadInteractiveFunctions(id)
          }
        })
    })
  }
}
